export default "__VITE_ASSET__C$liG5ni__"